<template>
  <div class="container">
    <div class="container_form">
      <el-form
        :inline="true"
        :model="queryForm"
        ref="queryFormRefs"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
      >
        <el-form-item label="结算批次名称" prop="settlementBatchName">
          <el-select
            filterable
            v-model="queryForm.settlementBatchName"
            placeholder="请选择结算批次名称"
            style="width: 200px"
            clearable
          >
            <el-option
              v-for="item in settlementBatchList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提成账号" prop="commissionUserIds">
          <el-select
            multiple
            filterable
            v-model="queryForm.commissionUserIds"
            placeholder="请选择提成账号"
            style="width: 200px"
          >
            <el-option
              v-for="item in commissionUserList"
              :key="item.id"
              :label="item.userName + '(' + item.account + ')'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="被提成师傅" prop="installerIds">
          <el-select
            multiple
            filterable
            v-model="queryForm.installerIds"
            placeholder="请选择被提成师傅"
            style="width: 200px"
          >
            <el-option
              v-for="item in installerList"
              :key="item.id"
              :label="item.userName + '(' + item.account + ')'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提成时间范围" prop="timeRange">
          <el-date-picker
            v-model="queryForm.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属公司" prop="companyIds">
          <el-select
            multiple
            filterable
            v-model="queryForm.companyIds"
            placeholder="请选择所属公司"
            style="width: 200px"
          >
            <el-option
              v-for="item in companyList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主机订单号" prop="mainOrderNo">
          <el-input
            v-model="queryForm.mainOrderNo"
            placeholder="请输入主机订单号"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="上游订单号" prop="upstreamOrderNo">
          <el-input
            v-model="queryForm.upstreamOrderNo"
            placeholder="请输入上游订单号"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerName">
          <el-input
            v-model="queryForm.customerName"
            placeholder="请输入客户名称"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getData">查询</el-button>
          <el-button type="info" size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="container_table">
      <div class="table_add">
        <el-button
          type="danger"
          icon="el-icon-refresh"
          size="small"
          v-show="authorization('/home-admin/commission-rule/record/reset')"
          @click="showResetDialog"
        >
          重置提成记录
        </el-button>
      </div>
      <BaseTable
        :tableData="tableData"
        :columns="columns"
        :showPagination="true"
        :showOperationColumn="false"
        :total="total"
        :page-size="page.pageSize"
        :current-page="page.pageNum"
        :pageSizes="sizes"
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        v-loading="loading"
        stripe
      >
        <template #commissionUserName="{ row }">
          <span
            style="color: #409eff; cursor: pointer"
            @click="showCommissionTotalDialog(row)"
          >
            {{ row.commissionUserName }}
          </span>
        </template>
        <template #installerName="{ row }">
          <span
            style="color: #409eff; cursor: pointer"
            @click="showInstallerTotalDialog(row)"
          >
            {{ row.installerName }}
          </span>
        </template>
        <template #addOutlay="{ row }">
          <span>{{ formatAmount(row.addOutlay) }}</span>
        </template>
        <template #commissionAmount="{ row }">
          <span>{{ formatAmount(row.commissionAmount) }}</span>
        </template>
        <template #commissionRate="{ row }">
          <span>{{ row.commissionRate }}%</span>
        </template>
        <template #createTime="{ row }">
          <span>{{ formatDateTime(row.createTime) }}</span>
        </template>
      </BaseTable>
      </div>
    </div>

    <!-- 重置提成记录Dialog -->
    <el-dialog
      title="重置提成记录"
      :visible.sync="resetDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="resetForm" ref="resetFormRef" label-width="120px">
        <el-form-item label="结算批次名称" prop="settlementBatchName" :rules="[{ required: true, message: '请选择结算批次名称', trigger: 'change' }]">
          <el-select
            filterable
            v-model="resetForm.settlementBatchName"
            placeholder="请选择结算批次名称"
            style="width: 100%"
          >
            <el-option
              v-for="item in resetBatchList"
              :key="item.settlementBatchName"
              :label="item.settlementBatchName"
              :value="item.settlementBatchName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmReset" size="small" :loading="resetLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 提成总金额Dialog -->
    <el-dialog
      title="提成总金额"
      :visible.sync="commissionTotalDialogVisible"
      width="400px"
    >
      <div style="padding: 20px">
        <p style="margin: 10px 0">
          <span style="font-weight: bold">当前结算批次增项提成总金额：</span>
          <span style="color: #409eff; font-size: 18px">{{ formatAmount(currentBatchCommissionTotal) }}</span>
        </p>
        <p style="margin: 10px 0">
          <span style="font-weight: bold">所有结算批次增项提成总金额：</span>
          <span style="color: #67c23a; font-size: 18px">{{ formatAmount(allBatchCommissionTotal) }}</span>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="commissionTotalDialogVisible = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 被提成总金额Dialog -->
    <el-dialog
      title="被提成总金额"
      :visible.sync="installerTotalDialogVisible"
      width="400px"
    >
      <div style="padding: 20px">
        <p style="margin: 10px 0">
          <span style="font-weight: bold">当前结算批次总被提成总金额：</span>
          <span style="color: #409eff; font-size: 18px">{{ formatAmount(currentBatchInstallerTotal) }}</span>
        </p>
        <p style="margin: 10px 0">
          <span style="font-weight: bold">所有结算批次增项被提成总金额：</span>
          <span style="color: #67c23a; font-size: 18px">{{ formatAmount(allBatchInstallerTotal) }}</span>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="installerTotalDialogVisible = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { authorization } from "@/authorization/authorization";
import BaseTable from "@/components/BaseTable";
import moment from "moment";

export default {
  name: "CommissionRecord",
  components: {
    BaseTable,
  },
  data() {
    return {
      queryForm: {
        settlementBatchName: "",
        commissionUserIds: [],
        installerIds: [],
        timeRange: [],
        companyIds: [],
        mainOrderNo: "",
        upstreamOrderNo: "",
        customerName: "",
      },
      tableData: [],
      total: 0,
      sizes: [10, 20, 50, 100],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: false,
      allUserList: [],
      commissionUserList: [], // 提成账号列表（实际数据）
      installerList: [], // 被提成师傅列表（实际数据）
      companyList: [],
      settlementBatchList: [],
      resetDialogVisible: false,
      resetForm: {
        settlementBatchName: "",
      },
      resetBatchList: [],
      resetLoading: false,
      commissionTotalDialogVisible: false,
      currentBatchCommissionTotal: 0,
      allBatchCommissionTotal: 0,
      currentCommissionUserId: null,
      currentCommissionBatchName: null,
      installerTotalDialogVisible: false,
      currentBatchInstallerTotal: 0,
      allBatchInstallerTotal: 0,
      currentInstallerId: null,
      currentInstallerBatchName: null,
      columns: [
        {
          prop: "settlementBatchName",
          label: "结算批次名称",
          showOverflowTooltip: true,
          width: 200,
        },
        {
          prop: "responsibleUserName",
          label: "结算师傅名称",
          showOverflowTooltip: true,
          width: 100,

        },
        {
          prop: "commissionUserName",
          label: "提成人名称",
          showOverflowTooltip: true,
          slot: "commissionUserName",
          width: 100,
        },
        {
          prop: "installerName",
          label: "被提成师傅",
          showOverflowTooltip: true,
          slot: "installerName",
        },
        {
          prop: "addOutlay",
          label: "增项金额",
          width: "120",
          slot: "addOutlay",
        },
        {
          prop: "commissionAmount",
          label: "提成金额",
          width: "120",
          slot: "commissionAmount",
        },
        {
          prop: "commissionRate",
          label: "提成比例",
          width: "100",
          slot: "commissionRate",
        },
        {
          prop: "commissionRemarks",
          label: "提成备注",
          showOverflowTooltip: true,
        },
        {
          prop: "companyName",
          label: "所属公司",
          showOverflowTooltip: true,
        },
        {
          prop: "brandName",
          label: "品牌",
          showOverflowTooltip: true,
        },
        {
          prop: "modelName",
          label: "车型",
          showOverflowTooltip: true,
        },
        {
          prop: "mainOrderNo",
          label: "主机订单号",
          width: 150,
          showOverflowTooltip: true,
        },
        {
          prop: "upstreamOrderNo",
          label: "上游订单号",
          width: 100,
          showOverflowTooltip: true,
        },
        {
          prop: "customerName",
          label: "客户名称",
          showOverflowTooltip: true,
        },
        {
          prop: "contactInfo",
          label: "联系方式",
          width: 100,
          showOverflowTooltip: true,
        },
        {
          prop: "vin",
          label: "车架号",
          width: 140,
          showOverflowTooltip: true,
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "160",
          slot: "createTime",
        },
      ],
    };
  },
  created() {
    this.getAllUserList();
    this.getCommissionUserList();
    this.getInstallerList();
    this.getCompanyList();
    this.getSettlementBatchList();
    this.getResetBatchList();
  },
  mounted() {
    // 页面挂载后立即查询数据
    this.getData();
  },
  activated() {
    // 如果使用了 keep-alive，从缓存恢复时也会触发
    this.getData();
  },
  methods: {
    authorization,
    getAllUserList() {
      this.$store.dispatch("setAllUserList").then(() => {
        this.allUserList = this.$store.state.allUserList;
      });
    },
    getCommissionUserList() {
      // 获取所有实际存在的提成账号列表
      this.axios({
        url: "/v1/web/commission-rule/record/commission-users",
        method: "get",
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.commissionUserList = res.data.data || [];
            console.log("提成账号列表加载成功:", this.commissionUserList.length, "个账号");
          } else {
            console.error("获取提成账号列表失败:", res.data.message);
            this.commissionUserList = [];
          }
        })
        .catch((error) => {
          console.error("获取提成账号列表异常:", error);
          this.commissionUserList = [];
        });
    },
    getInstallerList() {
      // 获取所有实际存在的被提成师傅列表
      this.axios({
        url: "/v1/web/commission-rule/record/installers",
        method: "get",
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.installerList = res.data.data || [];
            console.log("被提成师傅列表加载成功:", this.installerList.length, "个师傅");
          } else {
            console.error("获取被提成师傅列表失败:", res.data.message);
            this.installerList = [];
          }
        })
        .catch((error) => {
          console.error("获取被提成师傅列表异常:", error);
          this.installerList = [];
        });
    },
    getCompanyList() {
      // 直接调用接口获取公司列表
      this.axios({
        url: "/v1/web/company-manager/select-company-drown",
        method: "get",
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.companyList = res.data.data || [];
            console.log("公司列表加载成功:", this.companyList.length, "个公司");
          } else {
            console.error("获取公司列表失败:", res.data.message);
            this.companyList = [];
          }
        })
        .catch((error) => {
          console.error("获取公司列表异常:", error);
          this.companyList = [];
        });
    },
    getSettlementBatchList() {
      // 使用和重置提成记录一样的接口（获取已初始化成功的批次）
      this.axios({
        url: "/v1/web/commission-rule/record/batch-list",
        method: "get",
      })
        .then((res) => {
          if (res.data.code === 200) {
            // 接口返回的是批次状态对象数组，需要提取 settlementBatchName
            const batchList = res.data.data || [];
            this.settlementBatchList = batchList.map(item => item.settlementBatchName);
            console.log("结算批次列表加载成功:", this.settlementBatchList.length, "个批次");
          } else {
            console.error("获取结算批次列表失败:", res.data.message);
            this.settlementBatchList = [];
            this.$message.warning("获取结算批次列表失败: " + res.data.message);
          }
        })
        .catch((error) => {
          console.error("获取结算批次列表异常:", error);
          this.settlementBatchList = [];
          this.$message.error("获取结算批次列表失败，请刷新页面重试");
        });
    },
    getResetBatchList() {
      this.axios({
        url: "/v1/web/commission-rule/record/batch-list",
        method: "get",
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.resetBatchList = res.data.data || [];
            console.log("重置批次列表:", this.resetBatchList);
          } else {
            console.error("获取重置批次列表失败:", res.data.message);
            this.resetBatchList = [];
          }
        })
        .catch((error) => {
          console.error("获取重置批次列表异常:", error);
          this.resetBatchList = [];
        });
    },
    getData() {
      const data = {
        page: this.page.pageNum,
        size: this.page.pageSize,
        settlementBatchName: this.queryForm.settlementBatchName,
        commissionUserIds: this.queryForm.commissionUserIds,
        installerIds: this.queryForm.installerIds,
        startTime: this.queryForm.timeRange && this.queryForm.timeRange[0] ? this.queryForm.timeRange[0] + " 00:00:00" : null,
        endTime: this.queryForm.timeRange && this.queryForm.timeRange[1] ? this.queryForm.timeRange[1] + " 23:59:59" : null,
        companyIds: this.queryForm.companyIds,
        mainOrderNo: this.queryForm.mainOrderNo,
        upstreamOrderNo: this.queryForm.upstreamOrderNo,
        customerName: this.queryForm.customerName,
      };
      this.loading = true;
      this.axios({
        url: "/v1/web/commission-rule/record/list",
        method: "get",
        params: data,
        paramsSerializer: (params) => {
          // 自定义参数序列化：数组参数使用重复参数名格式，不使用方括号
          const parts = [];
          for (const key in params) {
            const value = params[key];
            if (value === null || value === undefined || value === '') continue;
            
            if (Array.isArray(value)) {
              // 数组参数：commissionUserIds=1&commissionUserIds=2
              value.forEach(item => {
                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
              });
            } else {
              // 普通参数
              parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
          }
          return parts.join('&');
        }
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getData();
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNum = 1;
      this.getData();
    },
    reset() {
      this.$refs.queryFormRefs.resetFields();
      this.queryForm = {
        settlementBatchName: "",
        commissionUserIds: [],
        installerIds: [],
        timeRange: [],
        companyIds: [],
        mainOrderNo: "",
        upstreamOrderNo: "",
        customerName: "",
      };
      this.getData();
    },
    showResetDialog() {
      this.resetForm.settlementBatchName = "";
      // 打开对话框时重新加载批次列表，确保数据是最新的
      this.getResetBatchList();
      this.resetDialogVisible = true;
    },
    confirmReset() {
      this.$refs.resetFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(
            `${this.resetForm.settlementBatchName} 结算批次关联的所有结算单，将会改成预结算状态，是否确认？`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.resetLoading = true;
              this.axios({
                url: "/v1/web/commission-rule/record/reset",
                method: "post",
                data: this.resetForm,
              })
                .then((res) => {
                  if (res.data.code === 200) {
                    this.$message.success(res.data.message || "重置成功");
                    this.resetDialogVisible = false;
                    this.getResetBatchList();
                    this.getData();
                  } else {
                    this.$message.error(res.data.message);
                  }
                })
                .finally(() => {
                  this.resetLoading = false;
                });
            })
            .catch(() => {});
        }
      });
    },
    showCommissionTotalDialog(row) {
      this.currentCommissionUserId = row.commissionUserId;
      this.currentCommissionBatchName = row.settlementBatchName;
      this.commissionTotalDialogVisible = true;
      this.loadCommissionTotal();
    },
    loadCommissionTotal() {
      // 当前批次
      this.axios({
        url: "/v1/web/commission-rule/record/commission-total",
        method: "get",
        params: {
          userId: this.currentCommissionUserId,
          batchName: this.currentCommissionBatchName,
          isCurrentBatch: true,
        },
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.currentBatchCommissionTotal = res.data.data || 0;
          }
        });
      // 所有批次
      this.axios({
        url: "/v1/web/commission-rule/record/commission-total",
        method: "get",
        params: {
          userId: this.currentCommissionUserId,
          batchName: null,
          isCurrentBatch: false,
        },
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.allBatchCommissionTotal = res.data.data || 0;
          }
        });
    },
    showInstallerTotalDialog(row) {
      this.currentInstallerId = row.installerId;
      this.currentInstallerBatchName = row.settlementBatchName;
      this.installerTotalDialogVisible = true;
      this.loadInstallerTotal();
    },
    loadInstallerTotal() {
      // 当前批次
      this.axios({
        url: "/v1/web/commission-rule/record/installer-total",
        method: "get",
        params: {
          installerId: this.currentInstallerId,
          batchName: this.currentInstallerBatchName,
          isCurrentBatch: true,
        },
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.currentBatchInstallerTotal = res.data.data || 0;
          }
        });
      // 所有批次
      this.axios({
        url: "/v1/web/commission-rule/record/installer-total",
        method: "get",
        params: {
          installerId: this.currentInstallerId,
          batchName: null,
          isCurrentBatch: false,
        },
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.allBatchInstallerTotal = res.data.data || 0;
          }
        });
    },
    formatDateTime(time) {
      if (!time) return "-";
      if (typeof time === "number") {
        return moment(time).format("YYYY-MM-DD HH:mm");
      }
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
    formatAmount(amount) {
      if (amount == null || amount === undefined) return "0.00";
      return parseFloat(amount).toFixed(2);
    },
    getInstallerIdFromOrder(orderId) {
      // 这个方法暂时返回null，实际应该从订单数据中获取
      // 由于表格数据中应该已经包含installerId，这里只是备用
      return null;
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.container_form {
  width: 100%;
  overflow: hidden;
}

.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}

.table_add {
  margin-bottom: 10px;
}
</style>

